import React from 'react';
import styled from '@emotion/styled';
import {colors} from '@atlaskit/theme';
import IconButton from '@mui/material/IconButton';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faXmark} from '@fortawesome/pro-light-svg-icons';

import {borderRadius, grid} from '../constants';

const getBackgroundColor = (isDragging, authorColors) => {
  if (isDragging) {
    return authorColors.soft;
  }

  return colors.N0;
};

const getBorderColor = (isDragging, authorColors) => (isDragging ? authorColors.hard : 'transparent');

const imageSize = 40;

const Container = styled.div`
  /*
  border-radius: ${borderRadius}px;
  border: 2px solid transparent;
  border-color: ${(props) => getBorderColor(props.isDragging, props.colors)};
  */
  background-color: ${(props) => getBackgroundColor(props.isDragging, props.colors)};
  /*
  box-shadow: ${({isDragging}) => (isDragging ? `2px 2px 1px ${colors.N70}` : 'none')};
  box-sizing: border-box;
  */
  padding: ${grid}px;
  min-height: ${imageSize}px;
  margin-bottom: ${grid}px;
  user-select: none;

  /* anchor overrides */
  color: ${colors.N900};

  &:hover,
  &:active {
    color: ${colors.N900};
    text-decoration: none;
  }

  &:focus {
    outline: none;
    border-color: ${(props) => props.colors.hard};
    box-shadow: none;
  }

  /* flexbox */
  display: flex;
  align-items: center;
`;

const Content = styled.div`
  /* flex child */
  flex-grow: 1;

  /*
    Needed to wrap text in ie11
    https://stackoverflow.com/questions/35111090/why-ie11-doesnt-wrap-the-text-in-flexbox
  */
  flex-basis: 100%;

  /* flex parent */
  display: flex;
  flex-direction: column;
`;

function getStyle(provided, style) {
  if (!style) {
    return provided.draggableProps.style;
  }

  return {
    ...provided.draggableProps.style,
    ...style,
  };
}

// Previously this extended React.Component
// That was a good thing, because using React.PureComponent can hide
// issues with the selectors. However, moving it over does can considerable
// performance improvements when reordering big lists (400ms => 200ms)
// Need to be super sure we are not relying on PureComponent here for
// things we should be doing in the selector as we do not know if consumers
// will be using PureComponent
function WordItem(props) {
  const {word, isDragging, provided, style, index, handleClickDeleteWord, isEditable} = props;

  return (
    <Container
      isDragging={isDragging}
      colors={{
        soft: colors.Y50,
        hard: colors.N400A,
      }}
      ref={provided.innerRef}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      style={getStyle(provided, style)}
      data-is-dragging={isDragging}
      data-testid={word.uuid}
      data-index={index}
    >
      <Content>
        <ListItem
          sx={{boxShadow: 1}}
          secondaryAction={
            isEditable && (
              <IconButton edge="end" onClick={() => handleClickDeleteWord(index)}>
                <FontAwesomeIcon icon={faXmark} className="clr-danger" />
              </IconButton>
            )
          }
        >
          <ListItemText primary={word.word} primaryTypographyProps={{variant: 'h5', className: 'fnt-bold'}} />
        </ListItem>
      </Content>
    </Container>
  );
}

export default React.memo(WordItem);
